<template>
    <div class="card m-0">
        <div class="card-content">
            <div class="card-body p-1">
                <form class="form form-horizontal" enctype="multipart/form-data">
                    <div class="form-body">
                        <div class="row">
                            <div class="col-12">
                                <div class="form-group row">
                                    <div class="col-md-1">
                                        <label for="durationSub">Nomlanishi</label>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="position-relative has-icon-left">
                                            <input type="text" placeholder="Nomlanishi..." class="form-control" id="durationSub"
                                                   v-model.trim="topic.name">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group row mb-0">
                                    <div class="col">
                                        <button v-if="update" type="button" class="btn btn-info waves-effect waves-light mr-1"
                                                data-dismiss="modal" @click="updateTopic"
                                                :disabled="topic.name.length === 0">
                                            Yangilash
                                        </button>

                                        <button v-else type="button" class="btn btn-info waves-effect waves-light mr-1" data-dismiss="modal"
                                                @click="storeSubject"
                                                :disabled="topic.name.length === 0">
                                            Saqlash
                                        </button>

                                        <button class="btn btn-outline-info waves-effect waves-light" type="button" data-dismiss="modal">
                                            Bekor qilish
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "TopicForm",
        props: {
            topic: Object
        },
        data() {
            return {
            }
        },
        methods: {

            storeSubject() {
                this.$api.post('admin/Reference/CreateSubjectTopic', this.topicFormData())
                    .then(res => {
                        if (!res.error) {
                            this.$emit('saved');
                            this.notificationMessage('Сохранено', 'success');
                        }
                    });
            },
            updateTopic() {
                this.$api.put('admin/Reference/UpdateSubjectTopic', this.topicFormData())
                    .then(res => {
                        if (!res.error) {
                            this.$emit('saved');
                            this.notificationMessage('Обновлено', 'success');
                        }
                    });
            },
            topicFormData() {
                let form = new FormData();
                for (let prop in this.topic)
                    form.append(prop, this.topic[prop]);

                return form;
            }
        },
        computed: {
            update() {
                return this.topic.id !== 0;
            }
        },
        watch: {},
        mounted() {}
    }
</script>

<style scoped>

</style>